import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(RouterLink)`
  text-decoration: none;
  color: inherit;
  
  &:hover {
    text-decoration: none;
  }
`;

const ScrollAwareLink = ({ 
  to, 
  children, 
  saveScrollPosition = false, 
  scrollToTop = true,
  ...props 
}) => {
  const location = useLocation();

  const handleClick = (e) => {
    if (saveScrollPosition && !scrollToTop) {
      // Save current scroll position before navigating
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const currentScrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      
      // Store in sessionStorage for immediate access
      sessionStorage.setItem(`scroll_${location.pathname}`, JSON.stringify({
        scrollTop: currentScrollTop,
        scrollLeft: currentScrollLeft,
        timestamp: Date.now()
      }));
      
      console.log(`💾 Saved scroll position for ${location.pathname}:`, { 
        scrollTop: currentScrollTop, 
        scrollLeft: currentScrollLeft 
      });
    } else if (scrollToTop) {
      // Clear any saved scroll position and ensure page starts from top
      sessionStorage.removeItem(`scroll_${to}`);
      console.log(`🗑️ Cleared scroll position for ${to} (scroll to top)`);
    }
  };

  return (
    <StyledLink 
      to={to} 
      onClick={handleClick}
      {...props}
    >
      {children}
    </StyledLink>
  );
};

export default ScrollAwareLink;
